// Login.jsx
// Simple login screen for trading app

import React, { useState } from 'react';
import { loginUser, setApiToken } from '../api';
import useStore from '../store';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const { setToken } = useStore();

  const handleLogin = async () => {
    if (!username || !password) {
      setError('Please enter username and password');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await loginUser(username, password);
      setApiToken(res.access_token);
      setToken(res.access_token);
      console.log('Token set in api.js:', res.access_token?.slice(0, 20));
      console.log('Token set in store:', res.access_token?.slice(0, 20));
    } catch (e) {
      setError('Invalid username or password');
    }
    setLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <div style={s.overlay}>
      <div style={s.card}>
        <div style={s.logo}>📈</div>
        <h2 style={s.title}>Trading Dashboard</h2>
        <p style={s.subtitle}>Sign in to continue</p>

        {error && <div style={s.error}>{error}</div>}

        <div style={s.field}>
          <label style={s.label}>Username</label>
          <input
            style={s.input}
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </div>

        <div style={s.field}>
          <label style={s.label}>Password</label>
          <input
            style={s.input}
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </div>

        <button
          style={{
            ...s.btn,
            opacity: loading ? 0.7 : 1,
            cursor:  loading ? 'not-allowed' : 'pointer',
          }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </div>
    </div>
  );
}

const s = {
  overlay: {
    position:       'fixed',
    top:            0, left: 0, right: 0, bottom: 0,
    background:     '#f0f2f5',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    zIndex:         9999,
  },
  card: {
    background:   '#fff',
    borderRadius: '12px',
    padding:      '40px',
    width:        '360px',
    boxShadow:    '0 4px 24px rgba(0,0,0,0.10)',
    textAlign:    'center',
  },
  logo: {
    fontSize:     '40px',
    marginBottom: '8px',
  },
  title: {
    fontSize:     '22px',
    fontWeight:   'bold',
    color:        '#131722',
    margin:       '0 0 4px 0',
  },
  subtitle: {
    fontSize:     '13px',
    color:        '#888',
    margin:       '0 0 24px 0',
  },
  error: {
    background:   '#ffebee',
    color:        '#c62828',
    padding:      '10px',
    borderRadius: '6px',
    fontSize:     '13px',
    marginBottom: '16px',
  },
  field: {
    textAlign:    'left',
    marginBottom: '16px',
  },
  label: {
    display:      'block',
    fontSize:     '12px',
    color:        '#555',
    marginBottom: '6px',
    fontWeight:   'bold',
  },
  input: {
    width:        '100%',
    padding:      '10px 12px',
    border:       '1px solid #ddd',
    borderRadius: '6px',
    fontSize:     '14px',
    outline:      'none',
    boxSizing:    'border-box',
  },
  btn: {
    width:        '100%',
    padding:      '12px',
    background:   '#2962ff',
    color:        '#fff',
    border:       'none',
    borderRadius: '6px',
    fontSize:     '14px',
    fontWeight:   'bold',
    marginTop:    '8px',
  },
};

export default Login;